import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaSearch, FaFilePdf, FaDollarSign, FaFileAlt } from 'react-icons/fa';
import { imprimirRastreamentoTitulo } from '~/Services/Service';

const AcoesAuxiliares = ({ titulo }) => {
  const [imprimindo, setImprimindo] = useState(false);

  if (!titulo) return null;

  const handleImprimir = async () => {
    setImprimindo(true);
    try {
      const blob = await imprimirRastreamentoTitulo(titulo.codigo_titulo);
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao gerar PDF.';
      toast.error(msg);
    } finally {
      setImprimindo(false);
    }
  };

  const cgcCpf = titulo.cgc_cpf || '';

  return (
    <Row className="mb-3">
      <Col xs={12}>
        <strong className="d-block mb-2">Ações Auxiliares</strong>
        <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Saldo de Contas — em breve</Tooltip>}
          >
            <span>
              <Button variant="outline-secondary" disabled>
                <FaDollarSign className="mr-1" />
                Saldo de Contas
              </Button>
            </span>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Visualiza Proposta — em breve</Tooltip>}
          >
            <span>
              <Button variant="outline-secondary" disabled>
                <FaFileAlt className="mr-1" />
                Visualiza Proposta
              </Button>
            </span>
          </OverlayTrigger>

          {cgcCpf ? (
            <Button
              as={Link}
              to={`/consulta-cgc-cpf?documento=${cgcCpf}`}
              variant="outline-primary"
            >
              <FaSearch className="mr-1" />
              Consulta CPF/CGC
            </Button>
          ) : (
            <Button variant="outline-primary" disabled>
              <FaSearch className="mr-1" />
              Consulta CPF/CGC
            </Button>
          )}

          <Button
            variant="outline-danger"
            onClick={handleImprimir}
            disabled={imprimindo}
          >
            <FaFilePdf className="mr-1" />
            {imprimindo ? 'Gerando PDF...' : 'Imprimir PDF'}
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default AcoesAuxiliares;
